const NAME = "RETIREMENT_DEFINITION";

export default NAME;
